<template>
  <!-- Header -->
  <div class="header">
    <div class="container">
      <div class="text-center mb-7">
        <div class="row justify-content-center">
          <div class="col-xl-5 col-lg-6 col-md-8 px-5">
            <i class="far fa-frown"></i>
            <h1>Ooops!</h1>
            <div
              class="mb-3"
            >Page not found. Don't worry though, we have plenty of other pages to explore.</div>
            <router-link to="/" class="font-weight-bold">BACK TO THE HOME PAGE</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "not-found-page",
  mounted() {
    this.$store.commit("setLayout", "page-layout");
  }
};
</script>

<style lang="scss" scoped>
.header {
  padding: 18rem 0 6rem;

  h1 {
    font-size: 3rem;
  }

  i {
    font-size: 8rem;
    margin-bottom: 2rem;
    color: grey;
  }
}
@media (max-width: 991.98px) {
  .header {
    padding: 12rem 0 4rem;

    i {
      font-size: 6rem;
    }
  }
}
</style>
